/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import bulkProvisioningTemplate from './bulk-provisioning/bulk-provisioning.dialog.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceTableConfig($q, $translate, $mdDialog, $document, $filter, $state, toast, types, utils, tkDialogs, userService,
                                           deviceService, networkSettingsService, apiLimitsService, deviceGroupService) {

    var deviceStateSubscriptions = {};

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(params) {

        var deferred = $q.defer();

        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;

        deviceGroupService.getDeviceGroup(params.applicationId).then(
            (deviceGroup) => {
                var tableConfiguration = createDeviceConfig(scope, access, params, deviceGroup.name);
                deferred.resolve(tableConfiguration);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function createDeviceConfig(scope, access, params, entityTitle) {

        var applicationId = params.applicationId;

        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.device,

            tableTitle: getTitle(scope, entityTitle),

            columns: [
                { key: 'createdTime',
                    title: 'entity.createdTime'},
                { key: 'name',
                    title: 'device.name'},
                { key: 'deviceEUI',
                    title: 'device.device-eui'},
                { key: 'devAddress',
                    title: 'device.device-address'},
                { key: 'appEUI',
                    title: 'device.app-eui'},
                {
                    key: 'online',
                    title: 'device.status',
                    cellContentFunction: (value) => {
                        if (value) {
                            return $translate.instant('device.online');
                        } else {
                            return $translate.instant('device.offline');
                        }
                    },
                    cellStyleFunction: (value) => {
                        if (value) {
                            return {color: '#1a901a'};
                        } else {
                            return {color: '#ff0000'};
                        }
                    }
                }
            ],

            addEntityController: 'AddDeviceController',
            bulkProvisioningTemplate: bulkProvisioningTemplate,
            bulkProvisioningController: 'DeviceBulkProvisioningController',

            loadEntities: ($scope) => {return loadDevices($scope, applicationId)},
            loadEntity: (entityId) => {return loadDevice(entityId)},
            saveEntity: (entity) => {return saveDevice(entity)},
            deleteEntity: (entityId) => {return deviceService.deleteDevice(entityId)},
            subscribeEntities: ($scope, entities) => {return subscribeForDevicesState($scope, entities)},
            unsubscribeAllEntities: () => {unsubscribeFromDeviceStates()},

            onDestroy: () => {
                unsubscribeFromDeviceStates();
            },

            addEnabled: () => {
                return access == types.access.admin;
            },

            detailsReadOnly: () => {
                return access == types.access.user;
            },
            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('device.delete-device-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('device.delete-device-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('device.delete-devices-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('device.delete-devices-text');
            }

        };

        tableConfiguration.actionCellDescriptors = [
            {
                 name: 'device.move-to-application',
                 icon: 'swap_vertical_circle',
                 isEnabled: () => {
                     return access === types.access.admin;
                 },
                 onAction: ($event, entity) => {
                     moveDeviceToApplication($event, entity, tableConfiguration);
                 }
            }
        ];

        tableConfiguration.groupActionDescriptors = [
            {
                 name: 'device.move-to-application',
                 icon: 'swap_vertical_circle',
                 isEnabled: () => {
                     return access === types.access.admin;
                 },
                 onAction: ($event, entities) => {
                     moveDevicesToApplication($event, entities, tableConfiguration);
                 }
            }
        ];

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

    function loadDevices($scope, applicationId) {
        var deferred = $q.defer();
        unsubscribeFromDeviceStates();
        deviceService.getDeviceGroupDevices(applicationId).then(
            (devices) => {
                deferred.resolve(devices);
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function unsubscribeFromDeviceStates() {
        for (var id in deviceStateSubscriptions) {
            deviceStateSubscriptions[id]();
        }
        deviceStateSubscriptions = {};
    }

    function subscribeForDevicesState($scope, devices) {
        devices.forEach(
            (device) => {
                if (angular.isUndefined(deviceStateSubscriptions[device.id.id])){
                    deviceStateSubscriptions[device.id.id] = deviceService.subscribeForDeviceStateData(device.id.id,
                        (deviceState) => {
                            var result = $filter('filter')(devices, {id: {id: device.id.id} }, true);
                            if (result && result.length) {
                                var entity = result[0];
                                $scope.$apply(() => {
                                    entity.online = deviceState.online;
                                });
                            }
                        }
                    );
                }
            }
        );
    }

    function moveDeviceToApplication($event, device, tableConfiguration) {
        var onEntitySelected = (targetApplicationId) => {
            device.applicationId = targetApplicationId;
            return deviceService.saveDevice(device);
        };
        tkDialogs.selectEntity($event, types.entityType.application,
            'device.move-to-application', 'action.move',
            'device.select-target-move-application-text',
            'application.application-not-found-text',
            'application.target-application-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function moveDevicesToApplication($event, devices, tableConfiguration) {
        var onEntitySelected = (targetApplicationId) => {
            var tasks = [];
            devices.forEach((device) => {
                device.applicationId = targetApplicationId;
                tasks.push(deviceService.saveDevice(device));
            });
            return $q.all(tasks);
        };
        tkDialogs.selectEntity($event, types.entityType.application,
            'device.move-to-application', 'action.move',
            'device.select-target-move-application-devices-text',
            'application.application-not-found-text',
            'application.target-application-required-text', onEntitySelected).then(
            () => { tableConfiguration.reloadEntities(true); }
        );
    }

    function getTitle(scope, entityTitle) {
        var title = $translate.instant('device.devices');
        if (entityTitle && entityTitle.length) {
            title = entityTitle + ': ' + title;
        }
        return title;
    }

    function loadDevice(deviceId) {
        var deferred = $q.defer();
        deviceService.getDevice(deviceId).then(
            (device) => {
                deviceService.getDeviceFCnts(deviceId).then(
                    (fCnts) => {
                        device.originFCnts = angular.copy(fCnts);
                        device.fCnts = fCnts;
                        networkSettingsService.getNetworkSettings(types.entityType.device, deviceId).then(
                            (networkSettings) => {
                                device.originNetworkSetting = angular.copy(networkSettings);
                                device.networkSettings = networkSettings;
                                apiLimitsService.getApiLimits(types.entityType.device, deviceId).then(
                                    (apiLimits) => {
                                        device.originApiLimits = angular.copy(apiLimits);
                                        device.apiLimits = apiLimits;
                                        deferred.resolve(device);
                                    },
                                    () => {
                                        deferred.reject();
                                    }
                                );
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                    },
                    () => {
                        deferred.reject();
                    }
                );
            },
            () => {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function saveDevice(device) {
        var deferred = $q.defer();
        var networkSettings = device.networkSettings;
        var apiLimits = device.apiLimits;
        var fCnts = device.fCnts;

        var originNetworkSettings = device.originNetworkSetting;
        var originApiLimits = device.originApiLimits;
        var originFCnts = device.originFCnts;

        function saveDeviceFCnts(device) {
            var deferred = $q.defer();
            deviceService.saveDeviceFCnts(device.id.id, fCnts).then(
                (fCnts) => {
                    device.fCnts = fCnts;
                    device.originFCnts = angular.copy(fCnts);
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                });
            return deferred.promise;
        }

        function saveApiLimits(device) {
            var deferred = $q.defer();
            apiLimitsService.saveApiLimits(apiLimits).then(
                (apiLimits) => {
                    device.apiLimits = apiLimits;
                    device.originApiLimits = angular.copy(apiLimits);
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        function saveNetworkSettings(device) {
            var deferred = $q.defer();
            networkSettingsService.saveNetworkSettings(networkSettings).then(
                (networkSettings) => {
                    device.networkSettings = networkSettings;
                    device.originNetworkSetting = angular.copy(networkSettings);
                    deferred.resolve(device);
                },
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        }

        var tasks = [];
        tasks.push(deviceService.saveDevice(device));
        if (!angular.equals(originNetworkSettings, networkSettings)) {
            tasks.push(saveNetworkSettings(device));
        }
        if (!angular.equals(originApiLimits, apiLimits)) {
            tasks.push(saveApiLimits(device));
        }
        if (!angular.equals(originFCnts, fCnts)) {
            tasks.push(saveDeviceFCnts(device));
        }

        $q.all(tasks).then(
            (results) => {
                deferred.resolve(results[results.length - 1]);
            },
            () => {
                deferred.reject();
            }
        );

        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/device/device-table.config.js